import React, { Fragment, useState, useEffect } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import Select from 'react-select';
import Button from '@mui/material/Button';
import CallIcon from '@mui/icons-material/Call';
import CircularProgress from '@mui/material/CircularProgress';
import { fetchData, deleteData, activateData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Tooltip } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const ServiceRequestFormEdit = () => {
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const { id } = useParams();
    const { isAuthenticated, companyId, userId, logout, token, companyName } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, token, logout, companyName]);

    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [formData, setFormData] = useState({
        checking_Company: '', // State to hold selected radio button value
        callNumber: '', // State to hold generated call number
        callSerialNo: '', // State to hold call serial number
    });


    const requestID = id;
    //Request Type
    const [requestTypeOptions, setRequestTypeOptions] = useState([]);
    const [selectedRequestType, setSelectedRequestType] = useState("");

    const fetchRequestTypes = async () => {
        try {
            const response = await fetchData('BrandApi', `/${companyId}`);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(type => ({
                    value: type.id,//name
                    label: type.name
                }));
                setRequestTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Request Types:', error);
        }
    };

    const handleRequestTypeChange = (selectedOption) => {
        setSelectedRequestType(selectedOption);
    };


    //Product Type
    const [productTypeOptions, setProductTypeOptions] = useState([]);
    const [selectedProductType, setSelectedProductType] = useState("");

    const fetchProductTypes = async () => {
        try {
            const response = await fetchData('CategoryApi', `/${companyId}`);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(product => ({
                    value: product.id, //name
                    label: product.name
                }));
                setProductTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Category Types:', error);
        }
    };

    const handleProductChange = (selectedOption) => {
        setSelectedProductType(selectedOption);
    };

    //Warrenty Type
    const [warrantyTypeOptions, setWarrantyTypeOptions] = useState([]);
    const [selectedWarrantyType, setSelectedWarrantyType] = useState("");

    const fetchWarrantyTypes = async () => {
        try {
            const response = await fetchData('WarrentyStatusApi', `/${companyId}`);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(warranty => ({
                    value: warranty.id, // type
                    label: warranty.type
                }));
                setWarrantyTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Warrenty Types:', error);
        }
    };

    const handleWarrantyChange = (selectedOption) => {
        setSelectedWarrantyType(selectedOption);
    };


    useEffect(() => {
        fetchWarrantyTypes();
        fetchRequestTypes();
        fetchProductTypes();
    }, []);

    const [amcStatus, setAmcStatus] = useState('');
    const [amcwarantydate, setAmcwarantydate] = useState('');
    useEffect(() => {
        fetchData('ServiceRequestApi', `/RequestDetails/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data);

                    const amcStatusValue = response.response_data.amc === 2 ? 'AMC' : 'Non AMC';
                    const amcwarantydateValue = response.response_data.amc === 2 ? response.response_data.warrentyExpireDate : 'No Date Required';

                    setAmcStatus(amcStatusValue);
                    setAmcwarantydate(amcwarantydateValue);

                    console.log(response);
                    console.log('AMC Status:', amcStatusValue);
                    console.log('AMC Warranty Date:', amcwarantydateValue);
                }
            })
            .catch((error) => {
                console.error('Error fetching Customer Details:', error);
            });
    }, [id, token]);


    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        // Update form data based on input type (text, checkbox, radio, etc.)
        setFormData((prevData) => ({
            ...prevData,
           // [name]: type === 'radio' ? value : value, 
            [name]: type === 'checkbox' ? checked : value, 
          
        }));
    };

    const generateCallNo = () => {
        const { checking_Company, callSerialNo } = formData;

        const formatDate = (date) => {
            const dd = String(date.getDate()).padStart(2, '0');
            const mm = String(date.getMonth() + 1).padStart(2, '0');
            return `${dd}/${mm}`;
        };

        let initials = '';

        if (callSerialNo && callSerialNo.trim() !== '') {
            // Split the existing call serial number
            const parts = callSerialNo.split('/');
            // Default initials to the 4th section of callSerialNo
            initials = parts[3];

            // Determine initials based on the selected company
            switch (checking_Company) {
                case '1':
                    initials = 'OT'; // Others
                    break;
                case '2':
                    initials = 'SC'; // Schneider
                    break;
                case '3':
                    initials = 'BR'; // Brother
                    break;
                default:
                    initials = parts[3]; // Default to the current 4th section of callSerialNo
                    break;
            }

            // Update the 4th section with the new initials based on selected company
            parts[3] = initials;

            // Construct the updated call number
            return parts.join('/');
        } else {
            // If callSerialNo is not defined or empty, return a default call number
            const currentDate = new Date();
            const formattedDate = formatDate(currentDate);

            return `EF/${formattedDate}/OT/02`;
        }
    };

    // Generate callNo here
    const callNo = generateCallNo();



    // Add Product Modal.
    const [productModelOptions, setProductModelOptions] = useState([]);
    const [selectedProductModel, setSelectedProductModel] = useState("");
    const fetchProductModal = async () => {
        try {
            const response = await fetchData('ProductModalApi', `/${companyId}`);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(productmodel => ({
                    value: productmodel.Id,
                    label: productmodel.Model
                }));
                setProductModelOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Product Modal:', error);
        }
    };
    const handleProductModalChange = (selectedOption) => {
        setSelectedProductModel(selectedOption);
    };

    useEffect(() => {
        fetchProductModal();
    }, []);


    const handleSubmit = async (event) => {
        event.preventDefault();

        setIsLoading(true);

        const updatedFormData = {
            ...formData,
            WarrentyStatusID: selectedWarrantyType.value,
            BrandID: selectedRequestType.value,
            ProductID: selectedProductType.value,
            CategoryID: selectedProductType.value,
            ModelID: selectedProductModel.value,
            ID: requestID,
            UpdatedBy: userId,
            EditedSerialNo: callNo,
            //CompanyCallNo : 
        };

        try {
            const response = await updateData('ServiceRequestApi', `${requestID}`, updatedFormData, token);
            console.log('Record updated successfully:', response.data);
            history.push('/ServiceRequestIndex');
        } catch (error) {
            console.error('Error updating record:', error);
            setIsLoading(false);
        }
    };

    return (
        <Fragment>
            <div style={{ backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bolder' }}>
                {successMessage && <p className="text-blue-500">{successMessage}</p>}
            </div>
            <div className="w-full max-w-sm container mt-6 mx-auto" style={{ maxWidth: '95%' }}>
                <form onSubmit={handleSubmit}>
                    <div className="w-full mb-2 flex items-center">
                        <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>SERVICE REGISTRATION - EDIT</h6>
                        <Tooltip title="Add to Call List">
                            <Button onClick={handleSubmit} style={{ color: 'darkgreen', fontWeight: 'bolder' }} disabled={isLoading}>
                                <CallIcon /> {isLoading ? <CircularProgress size={24} color="inherit" /> : "Update Call"}
                            </Button>
                        </Tooltip>
                        <Tooltip title="Exit">
                            <Link to="/ServiceRequestIndex" style={{ fontWeight: 'bolder', color: 'red', textDecoration: 'none' }}>
                                <Button style={{ color: 'brown', fontWeight: 'bolder' }}>
                                    Back To List  <ArrowForwardIosIcon />
                                </Button>
                            </Link>
                        </Tooltip>
                    </div>
                    <br />
                    <div className="w-full mb-4 flex">

                        <div className="w-1/7 radio-group" style={{ marginLeft: '10px' }}>
                            <div className="flex items-center">
                                <label className="block uppercase tracking-wide mr-2" style={{ color: 'brown' }}>
                                    <input
                                        type="radio"
                                        name="checking_Company"
                                        value="1"
                                        checked={formData.checking_Company?.toString() === '1'}
                                        onChange={handleChange}
                                    />
                                    Others
                                </label>
                                <label className="block uppercase tracking-wide mr-2" style={{ color: 'darkgreen' }}>
                                    <input
                                        type="radio"
                                        name="checking_Company"
                                        value="2"
                                        checked={formData.checking_Company?.toString() === '2'}
                                        onChange={handleChange}
                                    />
                                    Schneider
                                </label>
                                <label className="block uppercase tracking-wide mr-2" style={{ color: 'orangered' }}>
                                    <input type="radio"
                                        name="checking_Company"
                                        value="3"
                                        checked={formData.checking_Company?.toString() === '3'}
                                        onChange={handleChange} />
                                    Brother
                                </label>
                            </div>
                        </div>


                        <div className="w-1/6 mr-2" style={{ marginLeft: '5px' }}>
                            <label className="block tracking-wide text-black text-base mb-2" htmlFor="companyCallNo">
                                Company Call ID
                            </label>
                            {formData.companyCallNo ? (
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.companyCallNo}
                                    onChange={handleChange}
                                    name='companyCallNo'
                                    type="text"
                                />
                            ) : (
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.companyCallNo}
                                    onChange={handleChange}
                                    name='companyCallNo'
                                    type="text"
                                />
                            )}
                        </div>


                        <div className="w-1/6 mr-2">
                            <div>
                                <label className="block tracking-wide text-black text-base  mb-2" htmlFor="callSerialNo">
                                    Edited Call ID
                                </label>
                                {/* <p className="text-lg font-semibold text-gray-900">{callNo}</p> */}
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={callNo}
                                    style={{ fontWeight: 'bolder' }}
                                    disabled
                                />
                            </div>

                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block tracking-wide text-black text-base  mb-2" htmlFor="callSerialNo">
                                Call Number
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.callSerialNo}
                                onChange={handleChange}
                                name='callSerialNo'
                                type="text"
                                placeholder="Enter callSerialNo"
                                style={{ fontWeight: 'bolder' }}
                                disabled
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block tracking-wide text-black text-base mb-2" htmlFor="customerName">
                                Name
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.customer || ''}
                                onChange={handleChange}
                                name='customer'
                                type="text"
                                placeholder="Enter Name"
                                style={{ fontWeight: 'bolder' }}
                                disabled
                            />
                        </div>
                        <div className="w-1/7 mr-2">
                            <label className="block tracking-wide text-black text-base  mb-2" htmlFor="customertype">
                                Customer Type
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.customertype || ''}
                                onChange={handleChange}
                                name='customertype'
                                type="text"
                                style={{ fontWeight: 'bolder' }}
                                disabled
                            />
                        </div>

                        {/*Warranty check here if the customer is under AMC or not*/}
                        <div className="w-1/7 mr-2">
                            <label className="block tracking-wide text-black text-xs  mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                                AMC
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={amcStatus}
                                name='amcStatus'
                                type="text"
                                disabled
                                style={{ backgroundColor: 'white' }}
                            />
                        </div>

                        {/* {end} */}



                    </div>
                    <div className="w-full mb-4 flex">
                        <div className="w-1/7 mr-2">
                            <label className="block tracking-wide text-black text-xs mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                                Warranty Date
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={amcwarantydate}
                                name='amcwarantydate'
                                type="text"
                                disabled
                                style={{ backgroundColor: 'white' }}
                            />
                        </div>
                        <div className="w-1/4 mr-2">
                            <label className="block tracking-wide text-black text-base mb-2" htmlFor="contactNumber1">
                                Contact No
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.customerContact || ''}
                                onChange={handleChange}
                                name='customerContact'
                                type="text"
                                style={{ fontWeight: 'bolder' }}
                                disabled
                            />
                        </div>
                        <div className="w-1/2 mr-2">
                            <label className="block tracking-wide text-black text-base  mb-2" htmlFor="addressline1">
                                Address Line
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.address || ''}
                                onChange={handleChange}
                                name='address'
                                type="text"
                                style={{ fontWeight: 'bolder' }}
                                disabled
                            />
                        </div>
                        <div className="w-1/4 mr-2">
                            <label className="block tracking-wide text-black text-base  mb-2" htmlFor="landmark">
                                Landmark
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.landmark || ''}
                                onChange={handleChange}
                                name='landmark'
                                type="text"
                                style={{ fontWeight: 'bolder' }}
                                disabled
                            />
                        </div>
                        <div className="w-1/4 mr-2">
                            <label className="block tracking-wide text-black text-base  mb-2" htmlFor="email">
                                Email
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.email || ''}
                                onChange={handleChange}
                                name='email'
                                type="text"
                                style={{ fontWeight: 'bolder' }}
                            />
                        </div>

                    </div>
                    <div className="w-full mb-4 flex">
                        <div className="w-1/4 mr-2">
                            <label className="block tracking-wide text-black text-base  mb-2" htmlFor="productType">
                                Category
                            </label>
                            <Select

                                value={selectedProductType || (formData.product ? { value: formData.product, label: formData.product } : '')}
                                onChange={handleProductChange}
                                options={productTypeOptions}
                                placeholder="Select Category"
                                isSearchable
                            />
                        </div>
                        <div className="w-1/4 mr-2">
                            <label className="block tracking-wide text-black text-base  mb-2" htmlFor="requestType">
                                Brand
                            </label>
                            <Select

                                value={selectedRequestType || (formData.serviceRequestTypes ? { value: formData.serviceRequestTypes, label: formData.serviceRequestTypes } : '')}
                                onChange={handleRequestTypeChange}
                                options={requestTypeOptions}
                                placeholder="Select Brand"
                                isSearchable
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block tracking-wide text-black text-xs mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                                Product Model
                            </label>

                            <Select
                                // value={selectedProductModel}
                                value={selectedProductModel || (formData.productModel ? { value: formData.productModel, label: formData.productModel } : '')}
                                onChange={handleProductModalChange}
                                options={productModelOptions}
                                placeholder="Select Product Model"
                                isSearchable
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block tracking-wide text-black text-base mb-2" htmlFor="modal">
                                Model
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.modal || ''}
                                onChange={handleChange}
                                name='modal'
                                type="text"

                            />
                        </div>
                        <div className="w-1/4 mr-2">
                            <label
                                className="block tracking-wide text-black text-base  mb-2"
                                htmlFor="warrantyType"
                            >
                                Warranty
                            </label>
                            <Select
                                id="warrantyType"
                                //value={selectedWarrantyType || warranty}
                                value={selectedWarrantyType || (formData.warranty ? { value: formData.warranty, label: formData.warranty } : '')}
                                onChange={handleWarrantyChange}
                                options={warrantyTypeOptions}
                                placeholder="Select Warranty Type"
                                isSearchable
                            />
                        </div>
                        <div className="w-1/6 mr-2">
                            <span className="text-xs font-bold" style={{ fontSize: '14px', color: 'brown' }}>Is Priority ?</span>
                            <label className="flex items-center" style={{ fontSize: '30px', marginTop: '10px', marginLeft: '-70px' }}>
                                <input
                                    type="checkbox"
                                    name="isPriority"
                                    checked={formData.isPriority}
                                    onChange={handleChange}
                                    className="mr-2"
                                />
                            </label>

                        </div>
                    </div>
                    <div className="w-full mb-4 flex">
                        <div className="w-full mr-1">
                            <label className="block tracking-wide text-black text-base  mb-2" htmlFor="remark">
                                Remark <span style={{ color: 'red' }}>*</span>
                            </label>
                            <textarea
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.remarks || ''}
                                onChange={handleChange}
                                name='remarks'
                                type="text"
                            />
                        </div>

                    </div>
                </form>
            </div >
        </Fragment >
    );
};

export default ServiceRequestFormEdit;
